import { Box, Flex, Image } from '@chakra-ui/react';
import {  Pressable, Text, VStack } from 'components/ui';

const qrCode = '/onelinkto_nqnxxq-cp.png';
const iosBtn = '/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.png';
const playStoreBtn = '/google-play-badge.png';
const iosDownloadLink =
  'https://apps.apple.com/us/app/ayble-health-gi-gut-care/id1642365544';
const androidDownloadLink =
  'https://play.google.com/store/apps/details?id=com.ayblehealth.app';

const DownloadApp = () => {
  return (
    <Flex flexDirection={{ base: 'column', sm: 'row' }} gap={4}>
      <VStack w={104} gap={2} display={{base: 'none', sm: 'flex'}}>
        <Box
          flexShrink={0}
          backgroundColor="white"
          borderRadius={'6px'}
          borderWidth={2}
          padding={1.5}
          borderStyle="dashed"
          borderColor="secondary.200"
        >
          <Image
            alt="Ayble App"
            objectFit="contain"
            w="100%"
            h="100%"
            src={qrCode}
          />
        </Box>
        <Text
          fontFamily={'body'}
          fontSize={'11.5px'}
          fontWeight={400}
          lineHeight={'15.525px'}
          color={'blueGray.600'}
          textAlign={'center'}
        >
          Scan with your phone camera
        </Text>
      </VStack>
      <VStack w={158} gap={3}>
        <Pressable
          w="100%"
          href={iosDownloadLink}
          target="_blank"
        >
          <Image
            alt="Ayble ios App"
            w="100%"
            h="100%"
            src={iosBtn}
            objectFit="contain"
          />
        </Pressable>

        <Pressable
          w="100%"
          href={androidDownloadLink}
          target="_blank"
        >
          <Image
            alt="Ayble android App"
            w="100%"
            h="100%"
            src={playStoreBtn}
            objectFit="contain"
          />
        </Pressable>
      </VStack>
    </Flex>
  );
};

export default DownloadApp;
